import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-searchinput', 'clear', 'Clear input');
